import React from 'react';
import { getUuid } from '@front10/helpers/dist/uuid';
import {
  isPointContainedInBounds,
  isValidLocation,
  isPointShowMultipleTimes,
  getMapsWhereIsShowPoint,
  IS_SHOW_POINT
} from './../helpers/helper';

export const renderRouteLineFn = ({
  polylineSettings,
  originToDestinationLine,
  oldEndRouteMarker,
  route,
  showEndMarker,
  mapRef,
  cyclicMapPaddingWidth,
  calculateBezierSpline
}: any) => {
  const { GeoJSON } = require('react-leaflet');

  if (
    originToDestinationLine &&
    oldEndRouteMarker &&
    route.length > 0 &&
    showEndMarker &&
    isValidLocation(route[0]?.location) &&
    isValidLocation(oldEndRouteMarker?.location)
  ) {
    const basicLineProps = {
      color: '#777777',
      style: 'solid',
      weight: 3,
      interactive: false,
      ...polylineSettings
    };
    const useReducerBound = isPointShowMultipleTimes(
      route[0]?.location,
      oldEndRouteMarker?.location,
      mapRef
    );
    const routeLineInBounds = [
      isPointContainedInBounds(
        oldEndRouteMarker?.location[0],
        oldEndRouteMarker?.location[1],
        mapRef,
        useReducerBound,
        cyclicMapPaddingWidth
      ) ? (
        <GeoJSON
          key={`${oldEndRouteMarker?.label}${getUuid()}`}
          {...basicLineProps}
          data={calculateBezierSpline(route[0]?.location, oldEndRouteMarker?.location)}
        />
      ) : null,
      isPointContainedInBounds(
        oldEndRouteMarker?.location[0],
        oldEndRouteMarker?.location[1] - 360,
        mapRef,
        useReducerBound,
        cyclicMapPaddingWidth
      ) ? (
        <GeoJSON
          key={`${oldEndRouteMarker?.label}${getUuid()}`}
          {...basicLineProps}
          data={calculateBezierSpline(
            [route[0].location[0], route[0].location[1] - 360],
            [oldEndRouteMarker.location[0], oldEndRouteMarker.location[1] - 360]
          )}
        />
      ) : null,
      isPointContainedInBounds(
        oldEndRouteMarker?.location[0],
        oldEndRouteMarker?.location[1] + 360,
        mapRef,
        useReducerBound,
        cyclicMapPaddingWidth
      ) ? (
        <GeoJSON
          key={`${oldEndRouteMarker?.label}${getUuid()}`}
          {...basicLineProps}
          data={calculateBezierSpline(
            [route[0].location[0], route[0].location[1] + 360],
            [oldEndRouteMarker.location[0], oldEndRouteMarker.location[1] + 360]
          )}
        />
      ) : null
    ];
    for (let index = 0; index < routeLineInBounds.length; index++) {
      const routeLine = routeLineInBounds[index];
      if (routeLine) {
        return routeLine;
      }
    }
    const mapsWhenIsShowPoint = getMapsWhereIsShowPoint(
      route[0].location,
      oldEndRouteMarker.location,
      mapRef,
      0
    );
    if (mapsWhenIsShowPoint[0] === IS_SHOW_POINT) {
      return (
        <GeoJSON
          key={`${oldEndRouteMarker?.label}${getUuid()}`}
          {...basicLineProps}
          data={calculateBezierSpline(route[0].location, oldEndRouteMarker.location)}
        />
      );
    } else if (mapsWhenIsShowPoint[1] === IS_SHOW_POINT) {
      return (
        <GeoJSON
          key={`${oldEndRouteMarker?.label}${getUuid()}`}
          {...basicLineProps}
          data={calculateBezierSpline(
            [route[0].location[0], route[0].location[1] - 360],
            [oldEndRouteMarker.location[0], oldEndRouteMarker.location[1] - 360]
          )}
        />
      );
    } else if (mapsWhenIsShowPoint[2] === IS_SHOW_POINT) {
      return (
        <GeoJSON
          key={`${oldEndRouteMarker?.label}${getUuid()}`}
          {...basicLineProps}
          data={calculateBezierSpline(
            [route[0].location[0], route[0].location[1] + 360],
            [oldEndRouteMarker.location[0], oldEndRouteMarker.location[1] + 360]
          )}
        />
      );
    } else {
      return (
        <GeoJSON
          key={`${oldEndRouteMarker?.label}${getUuid()}`}
          {...basicLineProps}
          data={calculateBezierSpline(route[0].location, oldEndRouteMarker.location)}
        />
      );
    }
  }
};
